import { render, staticRenderFns } from "./TenderContentView.vue?vue&type=template&id=61255554"
import script from "./TenderContentView.vue?vue&type=script&lang=js"
export * from "./TenderContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports